import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "form-field-floating xl reactive active rounded-50 text-center mb-5" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createStaticVNode("<a href=\"#\" data-v-6ba0af90><div class=\"text-center mb-8\" data-v-6ba0af90><img src=\"/public/images/logo-wide.svg\" class=\"auth-logo\" data-v-6ba0af90></div></a><h2 class=\"font-semibold text-center my-6\" data-v-6ba0af90>Mot de passe oublié</h2><p class=\"text-read text-grey-600 text-center pb-5\" data-v-6ba0af90> Un lien pour réinitialiser votre code de sécurité vous a été envoyé. </p>", 3)),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input text-center",
            name: "identifiant",
            id: "identifiant",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.identifiant) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, _ctx.identifiant]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "identifiant" }, [
            _createTextVNode("Email ou numéro de téléphone "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5 mb-7",
          disabled: _ctx.isSubmitting
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            src: "/public/icons/icon-menu-securite.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.isSubmitting ? 'Envoi en cours...' : 'Réinitialiser'), 1)
        ], 8, _hoisted_4),
        _createVNode(_component_router_link, { to: "/signin" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("h5", { class: "text-primary-color text-center" }, "Voulez-vous annuler ?", -1)
          ]))]),
          _: 1
        })
      ], 32)
    ])
  ]))
}